import { hydrateRoot } from "react-dom/client";
import { StartClient } from "@tanstack/react-start/client";
import { setupI18n } from "./lib/i18n/setup";
import { installTranslationCrashGuard } from "./lib/translation-crash-guard";
import * as Sentry from "@sentry/react";

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Registers session replay so the replay sample rates below take effect.
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
  });
}

// Must run before hydrateRoot so the patched DOM methods are in place for every
// React commit. Fixes the browser-translation removeChild crash (ONLINE-ORDERING-R/-D/-F).
installTranslationCrashGuard();

async function hydrate() {
  // Get the current locale from the URL path
  const pathname = window.location.pathname;
  const localeMatch = pathname.match(/^\/([a-z]{2})/);
  const locale = localeMatch ? localeMatch[1] : "en";

  // Setup i18n with the correct locale before hydrating
  setupI18n(locale);

  // Route React 19's render-time errors to Sentry. These handlers are no-ops
  // in dev where Sentry is not initialized.
  hydrateRoot(document, <StartClient />, {
    onUncaughtError: Sentry.reactErrorHandler(),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  });
}

hydrate();
